import { isArray, trim } from 'lodash-es';

/**
 * 把任意列表归一化为「去空、去重、保留首次出现顺序」的字符串数组。
 * @param {unknown} list 原始入参（通常为 string[]）
 * @param {{ sort?: boolean, mapItem?: (raw: unknown) => unknown }} [options]
 * @param {boolean} [options.sort=false] 为 true 时对结果做字典序排序（如 hook 侧需稳定对拍）
 * @param {Function} [options.mapItem] 逐项转换后再 trim，如解开 Vue ref：`(item) => unref(item)`
 * @returns {string[]}
 *
 * @example
 * normalizeStringList([' a ', 'b', 'a']);           // ['a', 'b']
 * normalizeStringList(['b', 'a'], { sort: true }); // ['a', 'b']
 */
export function normalizeStringList(list, options = {}) {
  const { sort = false, mapItem } = options;
  if (!isArray(list)) {
    return [];
  }
  const seen = new Set();
  const out = [];
  for (const raw of list) {
    const value = mapItem ? mapItem(raw) : raw;
    const s = trim(String(value ?? ''));
    if (!s || seen.has(s)) {
      continue;
    }
    seen.add(s);
    out.push(s);
  }
  if (sort) {
    return out.sort();
  }
  return out;
}
